import LocaleContext from "components/i18n/LocaleContext";
import lightFormat from "date-fns/lightFormat";
import parseDateYmd from "lib/utils/parseDateYmd";
import { useContext } from "react";

interface ICorporateActionsSummaryProps {
  name: string;
  date?: string;
}

export default function CorporateActionsSummary({ name, date }: ICorporateActionsSummaryProps) {
  const locale = useContext(LocaleContext);
  return (
    <div className="flex flex-col items-center rounded-xl bg-slate-100 px-4 py-2 font-aeonik xl:inline-flex">
      <strong className="m-0 text-sm font-bold text-slate-800">
        {locale === "USA" ? "Last Corporate Action" : "Último Evento Corporativo"}
      </strong>

      <div className="space-x-1 text-sm font-medium text-slate-500">
        <span>{name}</span>
        {date && (
          <>
            <span>•</span>
            <span>{lightFormat(parseDateYmd(date), "dd/MM/yyyy")}</span>
          </>
        )}
      </div>
    </div>
  );
}
